import { useMetadata } from '#wa/composables/useMetadata'

export function sparklingRoseFiltersToUrl(filters) {
  if (
    filters.length === 2 &&
    filters.every(
      (filter) =>
        filter.category === 'categories' &&
        ['sparkling', 'rose'].includes(filter.key),
    )
  ) {
    return `sparkling-rose/`
  }
  return undefined
}

export function sparklingRoseUrlToFilters({ route }) {
  const metadata = useMetadata()
  if (route.params.category !== 'sparkling-rose' || !metadata.searchFilters)
    return undefined
  return metadata.searchFilters.filter(
    (filter) =>
      filter.category === 'categories' &&
      ['sparking', 'rose'].includes(filter.key),
  )
}
